export default "__VITE_ASSET__MQzsVb8t__"